import React from "react";
import { Header } from "./Header";
import FooterComponent from "./FooterComponent";
import { StaticImage } from "gatsby-plugin-image";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
  showLanguageSwitcher?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  className = "",
  showLanguageSwitcher = true,
}) => {
  return (
    <>
      <Header showLanguageSwitcher={showLanguageSwitcher} />
      <main
        className={`px-4 mx-auto max-w-screen-xl pt-16 lg:pt-0 ${className}`}
      >
        {children}
      </main>
      <FooterComponent />
      <div className="fixed bottom-0 m-1">
        <a href="mailto:office@noracares.at">
          <StaticImage
            src="../assets/icons/support-button.svg"
            alt="support button"
            height={130}
          />
        </a>
      </div>
    </>
  );
};
